import {
  GET_FEED_CUT_OFF_HISTORY,
  GET_FEED_MANUAL_PRICE_HISTORY,
  SET_FEED_CUT_OFF_HISTORY,
  SET_FEED_MANUAL_PRICE_HISTORY,
  SET_SOURCE_FEED_MANUAL_PRICE,
  SET_TOMEI_PRICE_MANUAL_PRICE,
  SET_CUT_OFF,
  SET_TOMEI_PRICE_ADJUSTMENT,
} from 'redux/constants/FeedPrice';

export const setSourceFeedManualPrice = (payload) => {
  return {
    type: SET_SOURCE_FEED_MANUAL_PRICE,
    payload,
  };
};

export const setTomeiPriceManualPrice = (payload) => {
  return {
    type: SET_TOMEI_PRICE_MANUAL_PRICE,
    payload,
  };
};

export const getFeedManualPriceHistory = (payload) => {
  return {
    type: GET_FEED_MANUAL_PRICE_HISTORY,
    payload,
  };
};

export const setFeedManualPriceHistory = (payload) => {
  return {
    type: SET_FEED_MANUAL_PRICE_HISTORY,
    payload,
  };
};

export const getFeedCutOffHistory = (payload) => {
  return {
    type: GET_FEED_CUT_OFF_HISTORY,
    payload,
  };
};

export const setFeedCutOffHistory = (payload) => {
  return {
    type: SET_FEED_CUT_OFF_HISTORY,
    payload,
  };
};

export const setCutOff = (payload) => {
  return {
    type: SET_CUT_OFF,
    payload,
  };
};

export const setTomeiPriceAdjustment = (payload) => {
  return {
    type: SET_TOMEI_PRICE_ADJUSTMENT,
    payload,
  };
};
